module.exports = __webpack_public_path__ + "img/power_bi.9434338f.png";